import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const container = css`
  display: flex;
  align-items: center;
  height: ${theme.spacing(4)};
  background-color: ${theme.colors.neutral10};
  border-radius: ${theme.spacing(0.75)};
  padding: ${theme.spacing(0.25)};
  width: fit-content;
`;

const optionContainer = (checked: boolean) => css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(0.5)};
  padding: ${theme.spacing(0.5, 1)};
  border-radius: ${theme.spacing(0.5)};
  background: ${checked ? theme.colors.white : 'transparent'};
  box-shadow: ${checked ? theme.shadows.light : 'none'};
  height: ${theme.spacing(3.5)};

  svg {
    color: ${theme.font.colors.subdued};
    height: ${theme.spacing(2)};
    min-height: ${theme.spacing(2)};
    width: ${theme.spacing(2)};
    min-width: ${theme.spacing(2)};
  }

  .content-switcher-label {
    font-weight: ${checked ? theme.font.weight.bold : theme.font.weight.regular};
    color: ${checked ? theme.font.colors.default : theme.font.colors.subdued};
  }

  &:hover {
    background-color: ${checked ? theme.colors.white : theme.colors.neutral20};
  }

  &:active {
    background: ${checked ? theme.colors.white : 'transparent'} !important;
    color: ${theme.font.colors.default} !important;

    svg {
      color: ${theme.font.colors.subdued} !important;
    }
  }

  &:focus-visible {
    box-shadow: ${theme.shadows.light};
  }
`;

export const ContentSwitcherStyles = {
  container,
  optionContainer,
};
